const RoundInfo = ({data}) => {
    if (data) {
        return (
            <div className="flex flex-col items-center text-primary font-primary space-y-10">
                <span className="uppercase text-2xl">{data.title}</span>
                <div className={
                    "md:ring-2 md:ring-white rounded-xl shadow-connectWallet flex flex-col items-between justify-between px-4 md:px-[5%] py-4  md:py-[5%] space-y-5 w-full"
                }>
                    {
                        data.details.map((e, index)=>{
                            return (
                                <div className="flex flex-row justify-between font-secondary font-medium text-md md:text-lg" key={index.toString()}>
                                    <span className="text-left text-[#7f7f7f] w-1/2 shrink-0">{e.title}</span>
                                    <span className={
                                        e.isSpecialValue ?
                                        "text-right text-maize" :
                                        "text-right text-primary"
                                    }>{e.value}</span>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        )
    }
    return null
}

export default RoundInfo;
